import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-unanswered-question-modal',
  templateUrl: './unanswered-question-modal.component.html',
  styleUrls: ['./unanswered-question-modal.component.css']
})
export class UnansweredQuestionModalComponent implements OnInit {

  isArabic = false;
  // commentHistory: any;
  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit(): void {
    //console.log(this.commentHistory);
  }
  closeModal() {
    this.bsModalRef.hide();
  }

}
